/**
 * TableTabSkeleton - Skeleton base para tabs con filtros y tabla
 * 
 * Usado como loading state para tabs de transacciones, ingresos, egresos, etc.
 */
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

interface TableTabSkeletonProps {
    /** Número de filtros a mostrar (default: 6) */
    filterCount?: number;
    /** Número de columnas en el header de la tabla (default: 12) */
    tableColumns?: number;
    /** Número de filas de datos (default: 6) */
    rowCount?: number;
}

const TableTabSkeleton = ({
    filterCount = 6,
    tableColumns = 12,
    rowCount = 6,
}: TableTabSkeletonProps) => (
    <div className="space-y-6">
        {/* Header con título y botón de acción */}
        <div className="flex justify-between items-center">
            <Skeleton className="h-10 w-[100px]" />
            <Skeleton className="h-10 w-[140px]" />
        </div>

        {/* Filtros */}
        <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-${filterCount} gap-4 items-end`}>
            {[...Array(filterCount)].map((_, i) => (
                <Skeleton key={i} className="h-10 w-full" />
            ))}
        </div>

        {/* Tabla */}
        <Card className="p-4">
            {/* Header de tabla */}
            <div className={`grid grid-cols-${tableColumns} gap-4 px-2 pb-4`}>
                {[...Array(tableColumns)].map((_, i) => (
                    <Skeleton key={`header-${i}`} className="h-5 w-full" />
                ))}
            </div>

            {/* Filas de datos */}
            <div className="space-y-4">
                {[...Array(rowCount)].map((_, i) => (
                    <Skeleton key={i} className="h-12 w-full" />
                ))}
            </div>
        </Card>
    </div>
);

export default TableTabSkeleton;
